/* ────────────────────────────────────────────────────────────────
   src/api/extract.js
   Envía el PDF al backend FastAPI y devuelve la tabla JSON
────────────────────────────────────────────────────────────────── */

const API = `http://${window.location.hostname}:8000`;

export const extractCfeTable = async (file) => {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch(`${API}/extract`, {
    method: "POST",
    body: form,
  });

  if (!res.ok) {
    const msg = await res.text();
    throw new Error(
      `Backend error ${res.status}: ${msg || res.statusText || "unknown"}`
    );
  }
  /* → [{Periodo,kWh,Importe,Pagado}, …] */
  return res.json();
};
